import TableHead from "./TableHead";


const TableU = () => {
  return (
    <div>
      <TableHead />
    </div>
  );
};

export default TableU;
